import {useTranslation} from "react-i18next";
import {useEffect, useState, useRef, useContext} from "react";
// -
import NavBreadcrum from "components/NavBreadcrum";
import TopBarActions from "components/TopBarActions";
import ButtonsActions from "views/utils/buttonsActions";
import TableExports from "./export/TableExports";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import axiApi from "ApiCaller";
import navs from "./navs";
import AuthContext from "context/AuthContext";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";

const ViewExport = () => {
    const {t: _Tr} = useTranslation("routes");
    const TBbuttons = useRef(new ButtonsActions());

    const [buttonsTB, setButtonsTB] = useState(TBbuttons.current);
    const bread = [
        {
            name: _Tr("labels.asset-management"),
            url: "/asset-management/",
            current: false,
        },
        {name: "Exportar", current: true},
    ];
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });
    const items = useRef(new ItemsModel());

    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);

    const [itemsShown, setItemsShown] = useState([]);
    const [checkboxAll, setCheckboxAll] = useState(false);

    useEffect(() => {
        TBbuttons.current.title = _Tr("labels.exportation");
        TBbuttons.current.export.active = true;
        TBbuttons.current.export.disabled = false;
        TBbuttons.current.export.onClick = onClickExport;
        TBbuttons.current.delete.active = true;
        TBbuttons.current.delete.disabled = true;
        TBbuttons.current.delete.onClick = onClickDelete;
        setButtonsTB({...TBbuttons.current});
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => fetchExports();

        fetchExports();
    }, []);

    const fetchExports = () => {
        setIsLoading(true);
        axiApi
            .get("/api/inventory/exports/", {
                params: pagerModelRef.current.paging.getParams(),
            })
            .then((resp) => {
                items.current.all = [...resp.data.items];
                items.current.showed = [...resp.data.items];
                items.current.chosen = [];
                items.current.checkboxes = [];
                setItemsShown([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onClickDelete = () => {
        AlertQuestion.info("Eliminar", `Se eliminaran los ${items.current.chosen.length} registros seleccionados.`).then(
            (resp) => {
                if (resp.isConfirmed) {
                    const ids = items.current.chosen.map((idx) => items.current.showed[idx].id);
                    axiApi.delete("/api/inventory/exports/", {data: {ids: ids}}).then((resp) => {
                        Alert.success("Eliminar", "Solicitud enviada correctamente");
                        items.current.showed = items.current.showed.filter((item) => !ids.includes(item.id));
                        setItemsShown([...items.current.showed]);
                        TBbuttons.current.counter = items.current.showed.length;
                        TBbuttons.current.delete.disabled = true;
                        setButtonsTB({...TBbuttons.current});
                    });
                }
            },
        );
    };

    const onClickCheckbox = (e) => {
        const {value, checked} = e.target;
        if (checked) {
            items.current.chosen.push(value);
            items.current.checkboxes.push(e.target);
        } else {
            items.current.chosen = items.current.chosen.filter((item) => item !== value);
            items.current.checkboxes = items.current.checkboxes.filter((item) => item !== e.target);
        }
        TBbuttons.current.delete.disabled = !(items.current.chosen.length > 0);
        setButtonsTB({...TBbuttons.current});
        setCheckboxAll(items.current.chosen.length === items.current.showed.length);
    };

    const onClickExport = () => {
        AlertQuestion.info("Exportar", "Por favor espere a la respuesta en las notificaciones").then((resp) => {
            if (resp.isConfirmed) {
                axiApi.post("/api/inventory/export/", {ids: []}).then((resp) => {
                    Alert.success("Exportar", "Solicitud enviada correctamente");
                });
            } else {
                Alert.info("Exportar", "Solicitud cancelada");
            }
        });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" />
            <LoaderSpinner isLoading={isLoading}>
                <TableExports
                    items={items}
                    itemsShow={itemsShown}
                    checkboxAll={checkboxAll}
                    setCheckboxAll={setCheckboxAll}
                    onClickCheckbox={onClickCheckbox}
                />
            </LoaderSpinner>
        </>
    );
};
export default ViewExport;
